
export default function Timeline() {
  const milestones = [
    {
      year: '2020',
      title: '브랜드 탄생',
      description: '유네스코 생물권보전지역의 천연 암반수를 발견하고, Heritage Water 프로젝트를 시작했습니다.'
    },
    {
      year: '2021',
      title: '지속 가능성 선언',
      description: '플라스틱 사용을 완전히 중단하고, 100% 재활용 가능한 알루미늄 캔으로 전환했습니다.'
    },
    {
      year: '2022',
      title: '품질 인증 획득',
      description: '국제 수질 기준을 충족하며, 프리미엄 천연미네랄워터로 공식 인증받았습니다.'
    },
    {
      year: '2023',
      title: '환경 보호 활동',
      description: '산지 보호 프로그램을 시작하고, 매출의 일부를 자연 보전에 기부하기 시작했습니다.'
    },
    {
      year: '2024',
      title: '글로벌 확장',
      description: '더 많은 사람들에게 더 나은 물을 제공하기 위한 글로벌 유통망을 구축했습니다.'
    }
  ];

  return (
    <section className="py-32 bg-white hidden md:block">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <p className="text-teal-600 font-medium text-sm tracking-wider uppercase mb-4">Our Journey</p>
          <h2 className="text-5xl lg:text-6xl font-light text-gray-900 mb-6">
            함께 걸어온 길
          </h2>
          <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto">
            더 나은 물을 향한 여정의 주요 순간들
          </p>
        </div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gradient-to-b from-teal-200 via-teal-400 to-teal-200"></div>

          {/* Timeline Items */}
          <div className="space-y-16">
            {milestones.map((milestone, index) => (
              <div 
                key={index}
                className={`flex items-center gap-8 ${
                  index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className={`w-1/2 ${index % 2 === 0 ? 'text-right pr-12' : 'text-left pl-12'}`}>
                  <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-xl transition-shadow">
                    <div className="text-4xl font-light text-teal-600 mb-3">{milestone.year}</div>
                    <h3 className="text-2xl font-medium text-gray-900 mb-3">{milestone.title}</h3>
                    <p className="text-gray-600 font-light leading-relaxed">{milestone.description}</p>
                  </div>
                </div>

                {/* Center Dot */}
                <div className="relative z-10">
                  <div className="w-6 h-6 bg-teal-600 rounded-full border-4 border-white shadow-lg"></div>
                </div>

                {/* Empty Space */}
                <div className="w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
